import { render, staticRenderFns } from "./WorkDetails.vue?vue&type=template&id=097a8ee7&scoped=true&"
import script from "./WorkDetails.vue?vue&type=script&lang=js&"
export * from "./WorkDetails.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetails.vue?vue&type=style&index=0&id=097a8ee7&lang=scss&scoped=true&"
import style1 from "./WorkDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097a8ee7",
  null
  
)

export default component.exports